var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4419_68283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 15.8418V51.096C80 66.6196 67.2902 79.2008 51.6104 79.2008H18.0207L17.2139 79.9995V79.2008H16.0038C7.16898 79.2008 0 72.1094 0 63.3585V28.1043C0 12.5807 12.7098 -0.000488281 28.3896 -0.000488281H63.9962C72.8352 -0.000488281 80 7.0909 80 15.8418Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4419_68283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2123 34.7571V46.0408C33.2123 47.2989 34.2406 48.3191 35.5135 48.3191H65.2102C65.2102 57.0659 58.0473 64.1572 49.2123 64.1572H36.3747C34.3535 64.1572 32.4159 64.9518 30.9863 66.3672L17.2165 79.9996V32.4788C17.2165 32.3422 17.2165 32.2077 17.2206 32.0712C17.4422 23.5127 24.5173 16.6406 33.2144 16.6406H62.911C64.1818 16.6406 65.2123 17.6587 65.2123 18.9189V30.2026C65.2123 31.4607 64.1839 32.4809 62.911 32.4809H35.5156C34.2448 32.4809 33.2144 33.499 33.2144 34.7591L33.2123 34.7571Z",
    fill: "url(#paint0_linear_4419_68283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1249 -0.000488281C29.4375 -0.000488281 16.14 5.421 16.0063 31.2744C16.0021 31.411 16.0021 31.5455 16.0021 31.6821V79.2029C7.16708 79.2029 0 72.1115 0 63.3605V28.1064C0 12.5827 12.7101 -0.000488281 28.3882 -0.000488281H44.1249Z",
    fill: "url(#paint1_linear_4419_68283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 15.8418V51.096C80 39.0404 73.0378 31.6821 61.6967 31.6821C62.9675 31.6821 63.9979 30.664 63.9979 29.4038V18.1201C63.9979 16.862 62.9696 15.8418 61.6967 15.8418H32C23.3029 15.8418 16.2278 22.7139 16.0063 31.2724C16.14 5.421 29.4375 -0.000488281 44.1249 -0.000488281H63.9979C72.8371 -0.000488281 80 7.09089 80 15.8418Z",
    fill: "url(#paint2_linear_4419_68283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 51.096C80 66.6197 67.2899 79.2008 51.6118 79.2008H16.0021L29.7719 65.5685C31.2016 64.1531 33.137 63.3585 35.1603 63.3585H47.9979C56.8329 63.3585 63.9958 56.2671 63.9958 47.5203H34.2992C33.0284 47.5203 31.9979 46.5022 31.9979 45.242V33.9583C31.9979 32.7002 33.0263 31.6801 34.2992 31.6801H61.6946C73.0357 31.6801 79.9979 39.0404 79.9979 51.0939L80 51.096Z",
    fill: "url(#paint3_linear_4419_68283)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4419_68283",
    x1: 15.8934,
    y1: 31.9987,
    x2: 69.0611,
    y2: 68.1112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4419_68283",
    x1: 22.1178,
    y1: 7.30403,
    x2: 21.6077,
    y2: 71.0066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2296F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#095FA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4419_68283",
    x1: 66.1445,
    y1: 40.5882,
    x2: 39.8042,
    y2: 10.8715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2296F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#095FA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4419_68283",
    x1: 43.7633,
    y1: 61.9452,
    x2: 68.3706,
    y2: 31.5663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2296F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#095FA4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4419_68283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 -0.000488281)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4419_68283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 -0.000488281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.771c1077.svg";
export { ForwardRef as ReactComponent };